import { useClaimHook } from 'hooks/claim.hook';
import useDialogConfirm from 'hooks/DialogConfirm.hook';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RootState } from 'store/store';
import { Button, Stack } from 'styles';
import { SEND_TO_REVIEW } from 'types/dialogTypes';
import { TRANSLATION_KEYS } from 'utils/constants';
import { useTranslation } from 'utils/translations';

const ReviewActions = () => {
	const { t: tClientLabels } = useTranslation('', {
		keyPrefix: TRANSLATION_KEYS.CLIENT_LABELS,
	});
	const { claimData } = useSelector((store: RootState) => store.claim);
	const dialogConfirm = useDialogConfirm();
	const { isReviewReady } = useClaimHook();
	const navigate = useNavigate();

	const handleClick = () => {
		navigate(-1);
	};

	const handleClickSendToReview = () => {
		const text = tClientLabels('dialog.sendToReview.content', {
			claimNumber: claimData.externalClaimId,
		});
		dialogConfirm.open(SEND_TO_REVIEW, text);
	};

	return (
		<Stack direction={'row'} justifyContent={'flex-end'} gap={'10px'} mb={'10px'}>
			<Button variant="outlined" onClick={handleClick}>
				{tClientLabels('commons.buttons.cancel')}
			</Button>
			<Button
				variant="contained"
				disabled={!isReviewReady}
				onClick={handleClickSendToReview}
			>
				{tClientLabels('claim.review.sendToReview')}
			</Button>
		</Stack>
	);
};

export default ReviewActions;
